var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"toastbox"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.toastShow),expression:"toastShow"}],staticClass:"toast"},[_vm._v(" "+_vm._s(_vm.info)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }